import { Skeleton, Card } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGymkhanaContent, selectGymkhanaData, selectGymkhanaStatus } from '../redux/gymkhanaSlice';
import WhatIsGymkhanaForm from '../components/whatIsGymkhana/WhatIsGymkhanaForm';
import Layout from '../components/layout/Layout';

const WhatIsGymkhanaPage = () => {
  const dispatch = useDispatch();
  const content = useSelector(selectGymkhanaData);
  const status = useSelector(selectGymkhanaStatus);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchGymkhanaContent());
    }
  }, [status, dispatch]);

  const handleSuccess = () => {
    dispatch(fetchGymkhanaContent());
  };

  if (status === 'loading' && !content) {
    return (
      <Layout title="What is Gymkhana Content">
        <div style={{ margin: '0 auto' }}>
          <Card style={{ borderRadius: '12px' }}>
            <Skeleton active title paragraph={{ rows: 2 }} />
            <Skeleton active title paragraph={{ rows: 4 }} style={{ marginTop: 24 }} />
            <Skeleton active title paragraph={{ rows: 6 }} style={{ marginTop: 24 }} />
            <Skeleton active title paragraph={{ rows: 2 }} style={{ marginTop: 24 }} />
          </Card>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="What is Gymkhana Content">
      <WhatIsGymkhanaForm
        initialValues={content}
        onSuccess={handleSuccess}
      />
    </Layout>
  );
};

export default WhatIsGymkhanaPage;
